import React from "react";
import { useStore } from "../stores/store";
import { ModalKeys } from "../interfaces/config";

export const ScaleTypeDropdown = () => {
  const { isLocal, scaleType, setScaleType, activateTool, deactivateTool } =
    useStore();

  const onScaleTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setScaleType(e.target.value);
    if (e.target.value === "scale") {
      activateTool(ModalKeys.SCALE_CONFIRMATION);
    } else {
      deactivateTool(ModalKeys.SCALE_CONFIRMATION);
    }
  };

  return (
    <div className="flex items-center w-24 mt-2">
      <label className="text-xs mr-1">Version:</label>
      <select
        value={scaleType}
        onChange={onScaleTypeChange}
        className="select select-xs text-gray-700"
      >
        <option value="default">Default</option>
        <option value="scale">Scale</option>
      </select>
    </div>
  )
};
